import { createSlice } from "@reduxjs/toolkit";
import { addMaterial, addMaterialsToClass, deleteMaterial, getAllMaterials, getMaterialsForClass } from "../services/material_service";
// ----------------------------------------------------------------------

const slice = createSlice({
    name: "material",

    initialState: {
        isLoadingAllMaterial: false,
        isLoadingAddMaterial: false,
        isLoadingDeleteMaterial: false,
        isLoadingAddMaterialsToClass: false,
        isLoadingGetMaterialsForClass: false,
        classMaterials: [],
        allMaterial: [],
    },



    reducers: {

    },


    extraReducers: {
        // ==> get All Materials
        [getAllMaterials.fulfilled]: (state, action) => {
            state.isLoadingAllMaterial = false;
            state.allMaterial = action.payload.data
            // if (action.payload.message === "School created successfully") {
            //     window.location.href = '/dashboard/confirmed-school'
            // }
        },
        [getAllMaterials.rejected]: (state, action) => {
            state.isLoadingAllMaterial = false;
        },
        [getAllMaterials.pending]: (state) => {
            state.isLoadingAllMaterial = true;
        },

        // ==> add Material
        [addMaterial.fulfilled]: (state, action) => {
            state.isLoadingAddMaterial = false;
        },
        [addMaterial.rejected]: (state, action) => {
            state.isLoadingAddMaterial = false;
        },
        [addMaterial.pending]: (state) => {
            state.isLoadingAddMaterial = true;
        },

        // ==> Delte Material
        [deleteMaterial.fulfilled]: (state, action) => {
            state.isLoadingDeleteMaterial = false;
        },
        [deleteMaterial.rejected]: (state, action) => {
            state.isLoadingDeleteMaterial = false;
        },
        [deleteMaterial.pending]: (state) => {
            state.isLoadingDeleteMaterial = true;
        },

        // ==> add Materials To Class
        [addMaterialsToClass.fulfilled]: (state, action) => {
            state.isLoadingAddMaterialsToClass = false;
        },
        [addMaterialsToClass.rejected]: (state, action) => {
            state.isLoadingAddMaterialsToClass = false;
        },
        [addMaterialsToClass.pending]: (state) => {
            state.isLoadingAddMaterialsToClass = true;
        },

        // ==> get Materials For Class
        [getMaterialsForClass.fulfilled]: (state, action) => {
            state.isLoadingGetMaterialsForClass = false;
            state.classMaterials = action.payload.data
        },
        [getMaterialsForClass.rejected]: (state, action) => {
            state.isLoadingGetMaterialsForClass = false;
        },
        [getMaterialsForClass.pending]: (state) => {
            state.isLoadingGetMaterialsForClass = true;
        },

    },

});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;
